<div class="center-block" style="width: 40%; padding: 20px">

    <div>
        @if (m_mode === 'EMAIL') {
            <div fxLayout="column" fxLayoutAlign="center center" class="fade-in">
                <br/>
                <h1>{{ 'general.openTicket' | transloco }}</h1>
                <app-contact></app-contact>
                @if (nextAgentD === 0 && nextAgentH === '00' && nextAgentM === '00' && nextAgentS === '00') {
                    <span class="countdown">
            {{ 'general.chatBeBack' | transloco }}...
          </span>
                } @else {
                    @if (nextAgentD === 0) {
                        <span class="countdown">{{ 'general.chatBeBackIn' | transloco }} <br/>{{ nextAgentH }} {{ 'general.hours' | transloco }} {{ nextAgentM }} {{ 'general.minutes' | transloco }} {{ nextAgentS }} {{ 'general.seconds' | transloco }}</span>
                    }
                    @if (nextAgentD !== 0) {
                        <span class="countdown">{{ 'general.chatBeBackIn' | transloco }} {{ nextAgentD }} {{ 'general.days' | transloco }} <br/> {{ nextAgentH }} {{ 'general.hours' | transloco }} {{ nextAgentM }} {{ 'general.minutes' | transloco }} {{ nextAgentS }} {{ 'general.seconds' | transloco }}</span>
                    }
                }
            </div>
        }
        @if (m_mode !== 'EMAIL') {
            <div fxLayout="column" fxLayoutAlign="center center">
                <br/>
                <span style="text-align: center">{{ 'general.chatHuman2' | transloco }}</span>
                <span style="text-align: center">({{ 'general.chatHuman3' | transloco }})</span>
                <br/>
                <br/>
                <mat-form-field>
                    <mat-label>{{ 'account.email' | transloco }}</mat-label>
                    <input matInput type="email" class="search-input"
                           #prmEmail="ngModel"
                           [email]="true"
                           [(ngModel)]="m_newUserName" placeholder="" autofocus autocomplete="off"/>
                </mat-form-field>
                @if (prmEmail.errors?.email) {
                    <div style="opacity: 0.4"> enter a valid e-mail address</div>
                }
                <br/>
                <mat-form-field>
                    <mat-label>{{ 'placeholder.message' | transloco }}</mat-label>
                    <input matInput type="text" class="search-input" [(ngModel)]="m_firstMessage" placeholder="" autofocus autocomplete="off"/>
                </mat-form-field>
                <br/>
                <button [disabled]="m_firstMessage.length <3 || m_newUserName.length < 3 || prmEmail.errors?.email" (click)="onClicked()" type="button" mat-raised-button>
                    {{ 'general.startLiveChat2' | transloco }}
                    <mat-icon>question_answer</mat-icon>
                </button>
            </div>
        }
    </div>
</div>
